import Link from "next/link";
import { ComponentProps, PropsWithChildren } from "react";

type MenuLink = {
  href: string;
} & PropsWithChildren &
  ComponentProps<"a">;

const Menulink = ({ children, href, ...rest }: MenuLink) => {
  return (
    <Link href={href} {...rest}>
      {children}
    </Link>
  );
};

export default Menulink;
